




import { BreadcrumbData, BreadcrumbItem } from '@/entities/breadcrumb/Breadcrumb';
import { PartCatalogueTree } from '@/entities/part-catalogue/PartCatalogueTree';
import BaseMixin from '@/mixins/BaseMixin';
import { PartCatalogueService } from '@/services/part-catalogue-service';
import Vue from 'vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Breadcrumb from './Breadcrumb.vue';

@Component({
    components: { Breadcrumb },
})
export default class PartCatalogueLandingPageBreadcrumb extends Mixins(BaseMixin) {
    private readonly partCatalogueService: PartCatalogueService = new PartCatalogueService();

    @Prop()
    private readonly initialBreadCrumb!: BreadcrumbData;

    @Prop()
    private readonly tree!: PartCatalogueTree;

    @Prop()
    private readonly currentId!: string;

    @Prop()
    private readonly pageBaseUrl!: string;

    private get breadCrumb(): BreadcrumbData {
        if (this.currentId) {
            let treeNode = this.partCatalogueService.getTreeNodeById(this.tree, this.currentId);

            if (treeNode) {
                const currentBreadCrumb: BreadcrumbData = {
                    items: [],
                    currentPage: '',
                };

                currentBreadCrumb.items.push(...this.initialBreadCrumb.items);
                currentBreadCrumb.items.push({
                    displayName: this.initialBreadCrumb.currentPage,
                    url: `${this.pageBaseUrl}/PartCatalogue`,
                });

                currentBreadCrumb.currentPage = treeNode.name;

                const partCatalougeBreadcrumbItems: BreadcrumbItem[] = [];

                while (treeNode && treeNode.parentTreeId) {
                    treeNode = this.partCatalogueService.getTreeNodeById(this.tree, treeNode.parentTreeId);

                    if (treeNode && treeNode.name !== '') {
                        partCatalougeBreadcrumbItems.push({
                            displayName: treeNode.name,
                            url: `${this.pageBaseUrl}/PartCatalogue/${treeNode.treeId}`,
                        });
                    }
                }

                currentBreadCrumb.items.push(...partCatalougeBreadcrumbItems.reverse());

                return currentBreadCrumb;
            }
        }

        return this.initialBreadCrumb;
    }
}
